import product1 from "./BQ900/BQ900.jpg";
import product1Img1 from "./BQ900/img1.jpg";
import product1Img2 from "./BQ900/img2.jpg";
import product1Img3 from "./BQ900/img3.jpg";
import product2 from "./BP900/BP900.jpg";
import product2Img1 from "./BP900/img1.jpg";
import product2Img2 from "./BP900/img2.jpg";
import product2Img3 from "./BP900/img3.jpg";
import product3 from "./BM900/BM900.jpg";
import product3Img1 from "./BM900/img1.jpg";
import product3Img2 from "./BM900/img1.jpg";
import product3Img3 from "./BM900/img3.jpg";
import product4 from "./BI900/BI900.jpg";
import product4Img1 from "./BI900/img1.webp";
import product4Img2 from "./BI900/img2.png";
import product4Img3 from "./BI900/img3.png";
import product5 from "./7900IS/7900IS.png";
import product5Img1 from "./7900IS/img1.jpg";
import product5Img2 from "./7900IS/img2.jpg";
import product6 from "./FX920/Fx-920.jpg";
import product6Img1 from "./FX920/img1.png";
import product6Img2 from "./FX920/img2.jpg";

import product7 from "./6200/6200.jpg";
import product7Img1 from "./6200/img1.jpg";
import product7Img2 from "./6200/img2.jpg";
import product7Img3 from "./6200/img3.png";
import product8 from "./7000/7000.jpg";
import product8Img1 from "./7000/img1.png";
import product8Img2 from "./7000/img2.webp";
export const HaagProducts = [
  {
    id: 1,
    name: 'BQ 900 Slit Lamp',
    title: "BQ 900 Slit Lamp",
    image:  product1,
    description: "Elevate your diagnostic precision with the BQ 900 slit lamp. Experience unmatched clarity and versatility for confident diagnosis and efficient patient care.",
    features: {
      feature1: "Superior optics and Galilean microscope system deliver exceptional image clarity and detail for precise diagnosis.",
      feature2: "Versatile illumination options, including slit and fill, accommodate various examination requirements.",
      feature3: "Ergonomic design and smooth controls optimize user comfort and efficiency during examinations.",
      feature4: "Compatibility with imaging systems and software enables documentation and analysis of clinical findings."
    },
    images: {
      product1Img1,
      product1Img2,
      product1Img3
    },
    link: "https://uk.haag-streit.com/products/categories/general-diagnostics/slit-lamps/bq-900"
    
  },
  {
    id: 2,
    name: 'BP 900 Slit Lamp',
    title: "BP 900 Slit Lamp",
    image: product2,
    description:
      "See clearer, diagnose faster with the BP 900 slit lamp. Advanced LED technology and ergonomic design for optimal eye exams.",
    features: {
      feature1: "Advanced LED illumination delivers exceptional brightness and color rendering for precise diagnosis.",
      feature2: "Ergonomic design and intuitive controls optimize user comfort and efficiency during extended examinations.",
      feature3: "Versatile magnification options and customizable slit settings accommodate various clinical needs.",
      feature4: "Compatibility with imaging systems and accessories enhances diagnostic capabilities and documentation."
    },
    images: {
      product2Img1,
      product2Img2,
      product2Img3
    },
    link:"https://uk.haag-streit.com/products/categories/general-diagnostics/slit-lamps/bp-900"
    },
  

  {
    id: 3,
    name: 'BM900 Slit Lamp',
    title: "BM900 Slit Lamp",
    image: product3,
    description: "The gold standard in slit lamp technology. Proven reliability, exceptional image quality, and ergonomic design for precise and efficient eye examinations.",
    features: {
      feature1: "Brilliant LED illumination delivers exceptional image clarity and color rendition for precise diagnosis.",
      feature2: "Ergonomic design and intuitive controls optimize user comfort and efficiency during extended examinations.",
      feature3: "Versatile magnification and slit settings accommodate a wide range of clinical applications.",
      feature4: "Modular design and compatibility with various accessories enhance customization and performance."
    },
    images: {
      product3Img1,
      product3Img2,
      product3Img3
    },
    link: "https://uk.haag-streit.com/products/categories/general-diagnostics/slit-lamps/bm-900"
  },
  {
    id: 4,
    name: 'BI900 Slit Lamp',
    title:'BI900 Slit Lamp',
    image: product4,
    description: "A modern update to the BM 900, offering enhanced features and improved illumination for even greater efficiency and accuracy",
    features: {
      feature1: "High-resolution digital imaging system captures detailed images for comprehensive documentation and analysis.",
      feature2: "Advanced LED illumination provides exceptional image clarity and color rendition for precise diagnosis.",
      feature3: "Ergonomic design and intuitive controls optimize user comfort and efficiency during extended examinations.",
      feature4: "Versatile magnification and slit settings accommodate a wide range of clinical applications."
    },
    images: {
      product4Img1,
      product4Img2,
      product4Img3
    },
    link: "https://uk.haag-streit.com/products/categories/general-diagnostics/slit-lamps/bi-900"
  },
  {
    id: 5,
    name: '7900 Instrument Stand',
    title: "7900 Instrument Stand",
    image: product5,
    description: "A sleek, ergonomic solution that maximizes efficiency and minimizes clutter in your exam room.",
    features: {
      feature1: "Stable and adjustable design accommodates various user preferences and instrument configurations.",
      feature2: "Large work surface provides ample space for instruments and accessories.",
      feature3: "Integrated storage compartments and drawers optimize workspace organization.",
      feature4: "Durable construction ensures long-lasting performance and stability."
    },
    images: {
      product5Img1,
      product5Img2,
    },
    link: "https://us.haag-streit.com/products/categories/general-diagnostics/stands-chairs-units/instrument-stands/7900-instrument-stand"
  },
  {
    id: 6,
    name: 'FX-920 Exam Chair',
    title: "FX-920 Exam Chair",
    image: product6,
    description: "A compact, efficient solution for your exam room, offering memory settings and versatile height options",
    features: {
      feature1: "Ergonomic design promotes optimal patient comfort and relaxation during examinations.",
      feature2: "Smooth and adjustable controls enable precise patient positioning for various procedures.",
      feature3: "Durable construction and easy-to-clean upholstery ensure long-lasting performance and hygiene.",
      feature4: "Compact footprint maximizes utilization of clinical space."
    },
    images: {
      product6Img1,
      product6Img2,
    },
    link: "https://us.haag-streit.com/products/categories/general-diagnostics/stands-chairs-units/examination-chairs/fx-920-exam-chair"
  },
  {
    id: 7,
    name: '6200 Exam Chair',
    title: '6200 Exam Chair',
    image: product7,
    description: "Enhance patient comfort and exam efficiency with its powerful hydraulic lift, manual pneumatic recline, and balanced design for easy operation from either side.",
    features: {
      feature1: "Ergonomic design and smooth hydraulic lift for efficient patient positioning and comfort.",
      feature2: "Manual pneumatic-assisted recline for versatile patient positioning and examination needs.",
      feature3: "Durable construction and easy-to-clean upholstery ensure long-lasting performance and hygiene.",
      feature4: "Compact footprint and flexible configuration options optimize clinical space utilization."
    },
    images: {
      product7Img1,
      product7Img2,
      product7Img3
    },
    link: "https://us.haag-streit.com/products/categories/general-diagnostics/stands-chairs-units/examination-chairs/6200-exam-chair"

  },
  {
    id: 8,
    name: '7000 Procedure Chair',
    title: '7000 Procedure Chair',
    image: product8,
    description: "Features a power base and top for effortless positioning, along with a memory function for quick access to frequently used settings",
    features: {
      feature1: "Ergonomic design and smooth electric lift for precise patient positioning and comfort.",
      feature2: "Versatile positioning options, including Trendelenburg and reverse Trendelenburg, for various procedures.",
      feature3: "Durable construction and easy-to-clean upholstery ensure long-lasting performance and hygiene.",
      feature4: "Integrated accessories and storage compartments optimize workflow and efficiency."
    },
    images: {
      product8Img1,
      product8Img2
    },
    link: "https://us.haag-streit.com/products/categories/general-diagnostics/stands-chairs-units/examination-chairs/7000-procedure-chair"
  },
  // ... more products
];